export default "__VITE_ASSET__COwmnFAc__"